export const AUTH_STATE_KEY = "isAuthenticated";
export const TOKEN_KEY = "authToken";